import api from "./axios";
import type {
  Review,
  PaginatedResponse,
  CreateReviewDto,
  UpdateReviewDto,
} from "@/types";
import { ApiPath } from "@/constants/api-routes";

export const reviewsApi = {
  getAll: (skip = 0, limit = 50) =>
    api
      .get<PaginatedResponse<Review>>(ApiPath.reviews(), {
        params: { skip, limit },
      })
      .then((r) => r.data),

  getById: (id: string) => api.get<Review>(ApiPath.review(id)).then((r) => r.data),

  getMine: (skip = 0, limit = 50) =>
    api
      .get<PaginatedResponse<Review>>(ApiPath.authMeReviews(), {
        params: { skip, limit },
      })
      .then((r) => r.data),

  create: (dto: CreateReviewDto) =>
    api.post<Review>(ApiPath.reviews(), dto).then((r) => r.data),

  update: (id: string, dto: UpdateReviewDto) =>
    api.patch<Review>(ApiPath.review(id), dto).then((r) => r.data),

  delete: (id: string) => api.delete(ApiPath.review(id)).then((r) => r.data),
};
